module.exports = __webpack_public_path__ + "img/galery-smart-scan-1-zoom.69fcf958.png";